var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Box, Flex, FormControl, FormLabel, Input, Text } from '@chakra-ui/react';
import { observer } from 'mobx-react';
import { StoreContext } from '@/app/uistore/Rootstore';
import React from 'react';
import { BeatLoader } from 'react-spinners';
import { BaseDialog } from '@/app/UIComponents/BaseDialog';
import { FontSize } from '../const/AppDefaults';
let RecoveryCodeDialog = class RecoveryCodeDialog extends React.Component {
    constructor(prop) {
        super(prop);
    }
    buildUserPasswordInput() {
        const rstore = this.context;
        return React.createElement(FormControl, { w: '300px', id: "userpassword", isRequired: true },
            React.createElement(FormLabel, null, "Login Password"),
            React.createElement(Input, { type: 'password', id: 'userpassword', placeholder: "Password", value: rstore.recoveryCodeDialog.password, onChange: (e) => rstore.recoveryCodeDialog.setPassword(e.currentTarget.value) }));
    }
    dialog() {
        const rstore = this.context;
        if (rstore.recoveryCodeDialog.loading) {
            return React.createElement(Flex, { w: '100%', h: '100%', align: 'center', justify: 'center' },
                React.createElement(BeatLoader, null));
        }
        if (rstore.recoveryCodeDialog.showpassword) {
            return this.buildUserPasswordInput();
        }
        return React.createElement(Box, null,
            React.createElement(Box, { style: {
                    marginTop: 50,
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                } },
                React.createElement(Text, { fontSize: FontSize.HeaderFontSize, fontWeight: 'bold' }, rstore.recoveryCodeDialog.secret),
                React.createElement(Text, { mt: '10px' }, "Please copy this recovery code. If you forget your passowrd you can use recovery code to recover your data and account.")));
    }
    render() {
        const rstore = this.context;
        return (React.createElement(BaseDialog, { body: this.dialog(), state: rstore.recoveryCodeDialog.bdialogstate }));
    }
};
RecoveryCodeDialog.contextType = StoreContext;
RecoveryCodeDialog = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], RecoveryCodeDialog);
export { RecoveryCodeDialog };
